module.exports = __webpack_public_path__ + "static/media/add canteen.1ef6518a.svg";